/**
 * BRAND — Identidade visual triple-brand Dimus / Guilherme Ribeiro
 *
 * Dimus:            agência (@dimusmkt)     — magenta+roxo corporativo
 * guilhermeribeiro.ai: avatar AI (@guilhermeribeiro.ai) — azul+verde futurista (IDV)
 * guilhermeribeiro.me: hub pessoal (@guilhermeribeiro.me) — premium, dark
 *
 * Uso: `import { BRAND, BRANDS } from "@/presets/brand";`
 * Default (BRAND) = guilhermeribeiro.ai — usado nas watermarks dos templates sociais.
 */

export const BRANDS = {
  /** Agência Dimus — uso em materiais de marketing da empresa */
  dimus: {
    name: "Dimus Marketing",
    handle: "@dimusmkt",
    tagline: "Marketing Que Vende",
    subTagline: "Transformando cliques em clientes",
    profileImage: "assets/profiles/guilhermeribeiro-me.jpg",
    logoUrl: "https://dimus.com.br/wp-content/uploads/2023/06/LOGO-dimus-branco.png",
    iconUrl: "https://dimus.com.br/wp-content/uploads/2023/06/icon-dimus-branco.png",
    colors: {
      primary:   "#D82AC8",   // magenta principal Dimus
      secondary: "#9317E8",   // roxo Dimus
      accent:    "#FF99FF",   // rosa claro Dimus
      bg:        "#0B0B0B",   // fundo dark Dimus
      surface:   "#232428",   // surface dark
      text:      "#FFFFFF",
      muted:     "#A0A0A0",
    },
    watermark: {
      text: "@dimusmkt",
      opacity: 0.55,
      fontSize: 16,
    },
    social: {
      instagram: "https://www.instagram.com/dimusmkt/",
      youtube: "@DimusMarketing",
      whatsapp: "+5567991992882",
    },
  },

  /** Perfil AI autônomo — conteúdo do experimento de IA ao vivo */
  guilherme_ai: {
    name: "Guilherme Ribeiro AI",
    handle: "@guilhermeribeiro.ai",
    tagline: "Gerenciado 100% por Inteligência Artificial",
    subTagline: "Experimento ao vivo",
    profileImage: "assets/profiles/guilhermeribeiro-ai.jpg",
    logoUrl: null,
    iconUrl: null,
    colors: {
      primary:   "#00DF82",   // verde neon IDV
      secondary: "#1E3A61",   // azul IDV
      accent:    "#FECB18",   // amarelo IDV
      bg:        "#0a0a0a",
      surface:   "#16171C",
      text:      "#FFFFFF",
      muted:     "#A0A0A8",
    },
    watermark: {
      text: "@guilhermeribeiro.ai",
      opacity: 0.5,
      fontSize: 14,
    },
    social: {
      instagram: "https://www.instagram.com/guilhermeribeiro.ai/",
    },
  },

  /** Hub pessoal — portfólio / site em construção */
  guilherme_me: {
    name: "Guilherme Ribeiro",
    handle: "@guilhermeribeiro.me",
    tagline: "Arquiteto do Experimento",
    subTagline: "Fundador Dimus",
    profileImage: "assets/profiles/guilhermeribeiro-me.jpg",
    logoUrl: null,
    iconUrl: null,
    colors: {
      primary:   "#1E3A61",   // azul IDV premium
      secondary: "#00DF82",   // verde neon IDV
      accent:    "#FECB18",   // amarelo IDV
      bg:        "#0a0a0a",
      surface:   "#111318",
      text:      "#FFFFFF",
      muted:     "#94A3B8",
    },
    watermark: {
      text: "@guilhermeribeiro.me",
      opacity: 0.5,
      fontSize: 14,
    },
    social: {
      instagram: "https://www.instagram.com/guilhermeribeiro.ai/",
    },
  },
} as const;

export type BrandKey = keyof typeof BRANDS;
export type Brand = (typeof BRANDS)[BrandKey];

/**
 * Brand padrão usado nos templates sociais (TikTok, Instagram, YouTube, etc.)
 * Usar @guilhermeribeiro.ai como watermark — identidade do conteúdo AI.
 */
export const BRAND = BRANDS.guilherme_ai;

/**
 * Helper: retorna brand por contexto
 * @param context - "agency" | "ai" | "personal"
 */
export const getBrand = (context: "agency" | "ai" | "personal" = "ai"): Brand => {
  if (context === "agency") return BRANDS.dimus;
  if (context === "personal") return BRANDS.guilherme_me;
  return BRANDS.guilherme_ai;
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
